var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookMessenger = function SvgFacebookMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13CFE8",
    d: "M14.023 3.15C7.897 3.15 3.15 7.626 3.15 13.673c0 3.163 1.3 5.897 3.416 7.785.365.329.29.52.352 2.548a.87.87 0 0 0 1.22.768c2.314-1.019 2.344-1.1 2.737-.993 6.706 1.846 13.975-2.446 13.975-10.108 0-6.047-4.699-10.525-10.826-10.525m6.53 8.099-3.194 5.056a1.634 1.634 0 0 1-2.359.434l-2.54-1.901a.66.66 0 0 0-.788 0l-3.429 2.6c-.458.347-1.057-.201-.749-.685l3.194-5.057a1.634 1.634 0 0 1 2.359-.434l2.54 1.901a.66.66 0 0 0 .787 0l3.43-2.597c.458-.35 1.057.198.749.683"
  })));
};
export default SvgFacebookMessenger;